<script>
import menuIcon from '@/components/view/menu-icon'
import globalNav from '@/components/view/global-nav'
import globalFooter from '@/components/view/global-footer'
import topVisual from '@/components/view/top-visual'
export default {
  components: {
    'menu-icon': menuIcon,
    'global-nav': globalNav,
    'global-footer': globalFooter,
    'topVisual': topVisual
  },
  data: () => ({
    siteName: '「GREAT PRETENDER」公式サイト',
    bootTime: Date.now(),
    reloadTime: 300, // 単位 秒
    isMobile: true,
    visibleNav: false,
    topVisualIndex: 0,
    inTransition: false,
    enterGlobalNav: false,
    enterMenuIcon: false,
    scrollStatus: {id: 0, id2: 0, documentBodyClientHeight: '', scrollTop: 0, leftColumnOverHeight: ''}
  }),
  computed: {
    contentTransitionName () {
      // const flg = this.enterGlobalNav || (this.isMobile && this.$route.name === 'home')
      return this.enterGlobalNav || (this.isMobile && this.$route.name === 'home') ? 'slide-enter-only' : 'slide-in'
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler (value) {
        if (Date.now() - this.bootTime > this.reloadTime * 1000) {
          location.reload()
        }
        this.activeElement = document.activeElement
        if (this.isMobile) {
          this.visibleNav = false
        }
        const titleTag = document.querySelector('head title')
        const pageTitle = (() => {
          if (value.path === '/') {
            return value.meta.pageTitle
          }
          if (value.meta.pageTitle) {
            return value.meta.pageTitle + ' |' + this.siteName
          }
          let pageItem = null
          if (Array.isArray(this.docs[value.meta.collection])) {
            const index = indexOf(this.docs[value.meta.collection], 'id', value.params[value.meta.docId])
            pageItem = this.docs[value.meta.collection][index]
          } else if (this.docs[value.meta.collection][value.params[value.meta.docId]]) {
            pageItem = this.docs[value.meta.collection][value.params[value.meta.docId]]
          } else {
            pageItem = {}
          }
          const title = pageItem.title
          const name = pageItem.name
          const contentTitle = title && name ? `${title} ${name}` : (title || name)
          return contentTitle + ' |' + this.siteName
        })()
        titleTag.innerHTML = pageTitle
        // eslint-disable-next-line
        /*gtag('config', gtagId, {
          page_path: value.fullPath,
          page_title: pageTitle
        })*/

        function indexOf (array, key, value) {
          if (!Array.isArray(array)) {
            return false
          }
          for (let i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
              return i
            }
          }
          return false
        }
      }
    }
  },
  created () {
    var mql = window.matchMedia('(orientation: portrait)')
    mql.addListener(() => {
      setTimeout(() => {
        this.setViewPort()
      }, 500)
    })
    this.setViewPort()
    window.onresize = this.setViewPort
  },
  mounted () {
    this.setScrollHandler()
    this.topVisualIndex = 4
    // モバイル用メニューの遅延表示 いったん短くする。
    setTimeout(() => {
      this.enterMenuIcon = true
    }, 100)
    /**
     * Windowsのみスタイル操作。横スクロールバーが表示されないための処置。CSSハックがなかったので。
     */
    if (window.navigator.userAgent.toLowerCase().indexOf('windows nt')) {
      const app = document.querySelector('.app')
      app.style.width = 'auto'
      app.style.overflowX = 'auto'
    }
  },
  methods: {
    setViewPort () {
      if (window.outerWidth > 768) {
        this.isMobile = false
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=1440')
        this.enterGlobalNav = false
        setTimeout(() => {
          this.setScrollHandler()
        }, 500)
        /* if (this.$route.name === 'home') {
          setTimeout(() => {
            this.visibleNav = true
          }, 1250)
        } else {
          this.visibleNav = true
        } */
        this.visibleNav = true
      } else {
        this.isMobile = true
        this.visibleNav = false
        this.enterGlobalNav = true
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1.0')
        // window.onscroll = null
      }
    },
    setScrollHandler () {
      const nav = document.querySelector('.global-nav')
      const leftColumn = document.querySelector('.global-nav .menu .scroll-container')
      const footer = document.querySelector('.global-footer')
      window.onscroll = () => {
        if (this.isMobile) {
          this.scrollHandlerMobile(footer)
        } else {
          this.scrollHandler(nav, leftColumn, footer)
        }
      }
    },
    scrollHandlerMobile (footer) {
      footer = footer || document.querySelector('.global-footer')
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop// クロスブラウザ対応
      this.scrollStatus.scrollTop = scrollTop
      if (scrollTop <= 0) {
        // 一番上
        this.scrollStatus.id2 = 1
      } else if (document.body.clientHeight - (scrollTop + window.innerHeight) <= footer.clientHeight) {
        // フッターが見えている状態
        this.scrollStatus.id2 = 2
      } else {
        // スクロール中
        this.scrollStatus.id2 = 3
      }
    },
    scrollHandler (nav, leftColumn, footer) {
      nav = nav || document.querySelector('.global-nav')
      leftColumn = leftColumn || document.querySelector('.global-nav .menu .scroll-container')
      footer = footer || document.querySelector('.global-footer')

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop// クロスブラウザ対応
      const leftColumnOverHeight = leftColumn.clientHeight - (window.innerHeight - 416)
      if (scrollTop <= 0) {
        // 一番上
        this.scrollStatus.id2 = 1
        nav.style.position = 'fixed'
        nav.style.bottom = 'auto'
      } else if (document.body.clientHeight - (scrollTop + window.innerHeight) <= footer.clientHeight) {
        // フッターが見えている状態
        this.scrollStatus.id2 = 2
        nav.style.position = 'absolute'
        nav.style.bottom = footer.clientHeight + 'px'
        leftColumn.scrollTop = Math.max(
          leftColumn.scrollTop,
          footer.clientHeight - (document.body.clientHeight - (scrollTop + window.innerHeight))
        )
      } else {
        // スクロール中
        this.scrollStatus.id2 = 3
        nav.style.position = 'fixed'
        nav.style.bottom = 'auto'
        if (this.scrollStatus.scrollTop > scrollTop) { // スクロールの向きがマイナスの時
          leftColumn.scrollTop = Math.min(leftColumn.scrollTop, scrollTop)
        }
      }
      this.scrollStatus.scrollTop = scrollTop
      this.scrollStatus.leftColumnOverHeight = leftColumnOverHeight
    },
    beforeEnter () {
      // this.inTransition = true
    },
    afterEnter () {
      /* this.inTransition = false
      setTimeout(() => {
        this.scrollHandler()
      }, 10) */
    },
    changeTopVisual (value) {
      this.topVisualIndex = value
    }
  }
}
</script>

<template>
  <div class="app">
    <transition :name="contentTransitionName">
      <top-visual
        v-if="$route.name === 'home' && topVisualIndex"
        :key="topVisualIndex"
        :index="topVisualIndex"
        :scrollTop="scrollStatus.scrollTop"
      ></top-visual>
    </transition>
    <transition name="slide-in">
      <menu-icon v-if="isMobile && enterMenuIcon" :visibleNav="visibleNav" @click="visibleNav = !visibleNav"/>
    </transition>
    <transition
      name="slide-in"
      @before-enter="enterGlobalNav = true"
      @after-leave="enterGlobalNav  = false"
    >
      <global-nav v-if="visibleNav"/>
    </transition>
    <div v-if="0" class="scroll-status">
      <div>{{ scrollStatus }}</div>
    </div>
    <div class="content-body">
      <transition
        :name="contentTransitionName"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
      >
        <router-view
          :isMobile="isMobile"
          :topVisualIndex="topVisualIndex"
          :scrollTop="scrollStatus.scrollTop"
          @scroll="scrollHandler"
          @changeTopVisual="changeTopVisual"
        />
      </transition>
    </div>
    <global-footer :scrollStatus="scrollStatus.id2" />
  </div>
</template>

<style lang="scss" scoped>
.app {
  position: relative;
  width: 100vw;
  overflow-x: hidden;
}
.content-body {
  min-height: 100vh;
  @include is-not-mobile {
    min-width: 65rem;
  }
}
.scroll-status {
  position:fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: none;
  color: #0F0;
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue